import React, {useEffect, useState} from "react";
import {BarChart} from "./BarChart";
import {useTranslation} from "react-i18next";
import {LineChart} from "./LineChart";
import Select from "react-select";
import {chartStyles} from "../../../../../../selectStyles";
import {CustomNoOptionsMessage} from "../../../../cms/form-components/CustomNoOptionsMessage";

export const QrFrequencyWidget = ({style}) => {
    const {t, i18n} = useTranslation();
    const charts = (t) => [
        {value: "bar", label: t("barChart")},
        {value: "line", label: t("lineChart")},
    ];
    const options = charts(t);
    const [chosenChart, setChosenChart] = useState(options[0]);

    useEffect(() => {
        setChosenChart(prev => options.find(o => o.value === prev?.value) ?? options[0]);
    }, [i18n.language]);

    const renderChart = () => {
        if (chosenChart?.value === 'line') {
            return <LineChart/>
        }
        return <BarChart/>
    }

    return (
        <div className={'statistic-widget qr-frequency'} style={style}>
            <div className={'qr-frequency-grid'}>
                <div className={'qr-frequency-header-wrapper'}>
                    <div className={'qr-frequency-header'}>
                        <p className={'scan-frequency-p'}>{t('scanFrequency')}</p>
                        <span className={'scan-frequency-span'}>{t('qrCode')}</span>
                        <div className={'widget-mode-selector'} style={{right: '15px'}}>
                            <Select id={'chart-selector'}
                                    name={'chart-selector'}
                                    value={chosenChart}
                                    placeholder={t('choose')}
                                    options={options}
                                    onChange={(selected) => setChosenChart(selected)}
                                    styles={chartStyles}
                                    components={{NoOptionsMessage: CustomNoOptionsMessage}}
                                    isSearchable={false}/>
                        </div>
                    </div>
                </div>
                {renderChart()}
            </div>
        </div>
    );
}